import { render, staticRenderFns } from "./Board-content.vue?vue&type=template&id=7b242195&scoped=true"
import script from "./Board-content.vue?vue&type=script&lang=js"
export * from "./Board-content.vue?vue&type=script&lang=js"
import style0 from "./Board-content.vue?vue&type=style&index=0&id=7b242195&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b242195",
  null
  
)

export default component.exports